import { Component } from 'react'
import * as styles from 'components/features/pfm/RateTabs/RateTabs.css'
import { AccountTyped, BaseCategoryInterest } from 'interfaces/accounts'
import { CategoryId, OpportunityCategoryId } from 'interfaces/meta'
import { ALL_CATEGORY_ID } from 'constants/meta'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import * as cn from 'classnames'

export type RateTabsStateProps = {
  opportunityCounters: Partial<Record<string, number>> | null
}

export type RateTabsDispatchProps = {
  onSeeOpportunitiesClick?: (categoryId: OpportunityCategoryId) => void
}

export type RateTabsOwnProps =
  & AccountTyped
  & {
    tabs: BaseCategoryInterest[]
    active: CategoryId
    setActiveTab: (active: CategoryId) => void
  }

export type RateTabsProps =
  & RateTabsStateProps
  & RateTabsDispatchProps
  & RateTabsOwnProps

// `\u00A0` is a `&nbsp`
const CATEGORY_PREFORMATTED_TITLES: Record<string, string> = {
  debt_other: `Personal\u00A0&\u00A0Other Loans`,
  home_equity: `Home\u00A0Equity Loans`,
  investment_savings: `Investments &\u00A0Savings`,
}

export class RateTabs extends Component<RateTabsProps, {}> {
  render () {
    const { tabs, type } = this.props
    const isDebtsPage = type === 'debts'

    const header = (
      <NavigationLink to={ isDebtsPage ? 'debts_rates' : 'assets_rates' }>
        <header className={ styles.header }>
          <div className={ styles.tabs }>
            { tabs.map(this.renderTab) }
          </div>
        </header>
      </NavigationLink>
    )

    return (
      <section className={ styles.rateTabs }>
        { header }
      </section>
    )
  }

  renderTab = (tab: BaseCategoryInterest) => {
    const { active, setActiveTab } = this.props
    const { category: { id }} = tab
    const isActive = id === active
    const className = cn(styles.tab, (styles as any)[id], {
      [styles.active]: isActive,
    })

    const handleClick = isActive
      ? undefined
      : () => setActiveTab(id)

    return (
      <div
        key={ id }
        data-qa-type='tab'
        data-qa-marker={ id }
        className={ className }
        onClick={ handleClick }
      >
        { this.renderTabTitle(tab) }
        { this.renderBadge(tab) }
      </div>
    )
  }

  renderTabTitle ({ category: { id, value: title }}: BaseCategoryInterest) {
    const displayTitle = id === ALL_CATEGORY_ID
      ? 'All'
      : CATEGORY_PREFORMATTED_TITLES[id] || title

    return (
      <span className={ styles.tabTitle }>
        { displayTitle }
      </span>
    )
  }

  renderBadge ({ category: { id }, opportunitiesCount }: BaseCategoryInterest) {
    return opportunitiesCount > 0 && id !== ALL_CATEGORY_ID
      ? (
        <span className={ styles.count } data-qa-type='opportunitiesCount'>
          { opportunitiesCount }
        </span>
      )
      : null
  }
}

export default RateTabs
